import { css } from "@pigment-css/react";
import { CheckmarkThin } from "@acto/web-common/components";
import { BaseCheckbox } from "@acto/web-common/base-components";
import { ComponentPropsWithoutRef } from "react";
import { clsx } from "clsx";

const checkboxRootStyle = css(({ theme }) => ({
  height: "22px",
  width: "22px",
  borderRadius: theme.radius.circular,
  border: `1px solid ${theme.colors.transparent[400]}`,
  backgroundColor: "transparent",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    borderColor: "#212226E5",
  },
  "&:active": {
    borderColor: theme.colors.transparent[500],
    backgroundColor: theme.colors.transparent[100],
  },
  '&[data-state="checked"]': {
    backgroundColor: "#212226E5",
    borderColor: "transparent",
    "&:hover": {
      backgroundColor: "#212226E5",
    },
    "&:active": {
      backgroundColor: "#212226E5",
    },
  },
  "&[data-disabled]": {
    cursor: "not-allowed",
  },
}));

const checkboxIndicatorStyle = css(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#21222673",
  opacity: 0,
  // For visual alignment with Figma (so the checkmark appears centered)
  transform: "translateX(0.5px) translateY(-0.5px)",
  "button:hover &": {
    opacity: 1,
  },
  'button[data-state="checked"] &': {
    opacity: 1,
    color: theme.colors.neutral[0],
  },
}));

// Full prop typing from Radix
// TODO: Consider using a more specific type if needed
type CheckboxProps = ComponentPropsWithoutRef<typeof BaseCheckbox>;

export const Checkbox = ({ className, disabled, onClickCapture, ...props }: CheckboxProps) => (
  <BaseCheckbox
    className={clsx(checkboxRootStyle, className)}
    slots={{ indicator: checkboxIndicatorStyle }}
    disabled={disabled}
    onClickCapture={(e) => {
      if (disabled) {
        e.stopPropagation();
        e.preventDefault();
        return;
      }
      onClickCapture?.(e);
    }}
    {...props}
  >
    <CheckmarkThin />
  </BaseCheckbox>
);
